module.exports = __webpack_public_path__ + "static/media/downRightArrow2.c6f29f9f.svg";